import React from 'react';
import { getCampaignProductListingPageUrl } from '@/url/product';
import { getImageUrl } from '@/utils/string';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { resetCampaignProductFilters } from '@/redux/reducers/campaign-products-reducer';
import { imageTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';
import TextLarge from '../Typography/TextLarge';

function OngoingCampaignCard({ imageSrc, alt = '', title = '', item }) {
  const router = useRouter();
  const dispatch = useDispatch();

  if (!item) {
    return;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    dispatch(resetCampaignProductFilters());

    router.push(
      getCampaignProductListingPageUrl({
        campaignSlug: item?.slug,
      }),
    );
  };

  return (
    <Link
      prefetch={false}
      aria-label="Go to ongoing campaign"
      href={getCampaignProductListingPageUrl({
        campaignSlug: item?.slug,
      })}
      passHref
      onClick={(e) => handleClick(e)}
    >
      <div className="w-[200px] lg:w-[320px] flex items-center gap-3 px-8 lg:px-20 py-8 lg:py-12 rounded-xl shadow-trending-categories-search hover:shadow-card-hover">
        <div className="min-w-[60px] lg:min-w-[80px] relative">
          <ImageComponentV2
            src={imageSrc ? getImageUrl(imageSrc) : null}
            alt={`Ongoing campaign - ${alt}`}
            className="size-[60px] lg:size-[80px] object-contain object-center rounded-xl"
            type={imageTypes.square}
            width={80}
            height={80}
            loading="lazy"
          />
        </div>
        <TextLarge className="text-sm font-semibold" text={title} />
      </div>
    </Link>
  );
}

export default OngoingCampaignCard;
